import React, { Component } from "react";
import { withRouter } from "react-router";
import { sendEvent} from '../util/utils'
import {PRODUCTION_UNIT_FEDERATIONS} from '../constants';
class Labs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
    };
  }

	renderUnits(){
		let unitsList = []
		if(this.props.unitsStatus){
			Object.keys(this.props.unitsStatus).forEach(index => {
				let unit = this.props.unitsStatus[index]
				unitsList.push((
						<li 
						className="unit-link"
						key={index}
						onClick={()=> sendEvent("apply-production-unit-filter", {productionUnit: index})}
						onMouseOver={()=> sendEvent('highlight-unit',[index, false])}
						>
							<span className="unit-name">{unit.aliasProdUnit}
								<span className="unit-state"> ({PRODUCTION_UNIT_FEDERATIONS[unit.aliasProdUnit]})</span>
							</span>
							<span className="unit-exams-qty">{unit['TOTAL']}</span>
						</li>
				))
			})
		}
		return unitsList;
	}

  render() {
		this.renderUnits();
    return (
			<>
				<div className="lab-container-title mb-15">
					<h3 className="lab-title">Exames por unidades</h3>
				</div>
				<ul className="units-list" onMouseOut={()=> sendEvent('highlight-unit',[])} >
					{this.renderUnits()}
				</ul>
			</>
    );
  }
}

export default withRouter(Labs);
